import moment from "moment";
import React from "react";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("admin-profile"));

  return (
    <>
      <div className="h-full mt-5">
        <div className="border-b-2 block md:flex">
          <div className="w-full md:w-2/5 p-4 sm:p-6 lg:p-8 bg-white shadow-md">
            <div className="flex justify-between">
              <span className="text-xl font-semibold block">
                {user.userType} Profile
              </span>
            </div>
            <div className="w-full p-8 mx-2 flex justify-center">
              <img
                id="showImage"
                className="items-center border"
                style={{ borderRadius: "50%", width: "200px", height: "200px" }}
                src={user.avatar}
                alt="user_pic"
              />
            </div>
          </div>
          <div className="w-full md:w-3/5 p-8 bg-white lg:ml-4 shadow-md">
            <div className="rounded shadow p-6">
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Name
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={user.fullname}
                  />
                </div>
              </div>
              <div className="pb-4">
                <label
                  htmlFor="about"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Email
                </label>
                <input
                  disabled
                  id="email"
                  className="border-1 rounded-r px-4 py-2 w-full"
                  type="email"
                  value={user.email}
                />
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Phone Number
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={user.phonenumber}
                  />
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Address
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={user.fulladdress}
                  />
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Gender
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={user.gender}
                  />
                </div>
              </div>{" "}
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  DOB
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={moment(user.dob).format("MMMM Do YYYY")}
                  />
                </div>
              </div>{" "}
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Profile Created At
                </label>
                <div className="flex">
                  <input
                    disabled
                    id="username"
                    className="border-1 rounded-r px-4 py-2 w-full"
                    type="text"
                    value={moment(user.createdAt).fromNow()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
